import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Star, Pencil, Check } from "lucide-react";
import { api, formatErr } from "@/lib/api";

const fmt = (n) => n.toLocaleString("de-DE");

export function StarInfo({ star, mine, onRenamed }) {
  const [edit, setEdit] = useState(false);
  const [name, setName] = useState(star?.name || "");
  useEffect(() => { setName(star?.name || ""); setEdit(false); }, [star?.user_id, star?.name]);
  if (!star) return null;
  const save = async () => {
    try { const { data } = await api.post("/sky/my-star", { name }); toast.success("Dein Stern hat einen neuen Namen ✨"); setEdit(false); onRenamed(data.name); } catch (e) { toast.error(formatErr(e)); }
  };
  return (
    <div className={`rounded-2xl p-4 border ${mine ? "bg-amber-200/10 border-amber-200/40" : "bg-white/5 border-white/10"}`} data-testid={mine ? "sky-my-star" : "sky-star-info"}>
      <p className="text-[11px] font-bold uppercase tracking-[0.25em] text-pink-300 flex items-center gap-1.5"><Star className="w-3.5 h-3.5" fill="currentColor" /> {mine ? "Dein Stern" : `Stern von ${star.owner}`}</p>
      {edit ? (
        <div className="flex gap-2 mt-2">
          <input value={name} maxLength={24} onChange={(e) => setName(e.target.value)} data-testid="sky-star-name-input" className="flex-1 min-w-0 h-10 rounded-xl bg-white/10 border border-white/20 px-3 text-white font-bold outline-none focus:border-amber-200" />
          <button onClick={save} data-testid="sky-star-name-save" aria-label="Speichern" className="h-10 w-10 rounded-full bg-amber-200 text-indigo-950 inline-flex items-center justify-center"><Check className="w-4 h-4" /></button>
        </div>
      ) : (
        <p className="font-display text-xl font-extrabold text-amber-100 mt-1 flex items-center gap-2" data-testid="sky-star-name">
          {star.name}
          {mine && <button onClick={() => setEdit(true)} data-testid="sky-star-rename" aria-label="Umbenennen" className="text-indigo-200 hover:text-white"><Pencil className="w-4 h-4" /></button>}
        </p>
      )}
      <p className="text-xs text-indigo-200 mt-1">leuchtet mit {fmt(star.amount)} Sternenstaub{mine ? " · je mehr du beiträgst, desto heller strahlt er" : ""}</p>
    </div>
  );
}
